<!-- @if(beginRender){ -->
<app-page-container class="turnover-container" [props]="props" [dynamicFormArray]="filterSchema" [title]="title"
[tabConfig]="tabSchema" [layoutType]="LayoutType.Tab" [label]="label">
</app-page-container>
<!-- } -->